import React, { useState } from "react";
import {
  TableContainer,
  Table,
  Thead,
  Tbody,
  Tr,
  Th,
  Td,
  Badge,
  Tag,
  TagLabel,
  Box,
  Flex,
  HStack,
  Input,
  Button,
  Text
} from "@chakra-ui/react";
import { useNavigate } from "react-router-dom"; // Import navigation hook
import { useAppContext } from "../../contexts/AppContext";
import TableFilters from "../general/TableFilters";
import { Plus } from "lucide-react";

// ... imports identiques

const InvestmentsTable = ({ fund }) => {
  const { formatDate, tableSize, formatMillions } = useAppContext();
  const navigate = useNavigate();
  const [searchTerm, setSearchTerm] = useState("");
  const [filters, setFilters] = useState({});

  const labelMap = {
    type: "Type",
  };
  const filterOptions = {
    type: [
      "Real Estate",
      "Debt",
      "Private Equity",
      "Feeder",
      "Venture Capital",
      "Multi",
    ],
  };

  const handleRowClick = (investmentName) => {
    const formattedInvestmentName = investmentName.replace(/ /g, "-");
    const formattedFundName = fund.fundName.replace(/ /g, "-");
    const url = `/funds/${formattedFundName}/investment/${formattedInvestmentName}`;
    navigate(url);
  };

  // ✅ Appliquer recherche + filtre par type
  const filteredInvestments = fund.investmentsTable.filter((investment) => {
    const matchesSearch = investment.investmentName
      .toLowerCase()
      .includes(searchTerm.toLowerCase());

    const matchesType =
      !filters.type ||
      filters.type.length === 0 ||
      filters.type.includes(investment.type);

    return matchesSearch && matchesType;
  });

  return (
    <Flex direction="column" gap={8}>
      <Flex gap={2} flex={1} justifyContent={"space-between"}>
        <HStack>
          <Input
            placeholder="Search by investment name..."
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
            flex={1}
            w={"260px"}
          />

          <TableFilters
            filters={filters}
            setFilters={setFilters}
            filterOptions={filterOptions}
            labelMap={labelMap}
          />
        </HStack>
        <Button leftIcon={<Plus size={16} />}>Add an investment</Button>
      </Flex>

      <TableContainer>
        <Table variant="simple" size={tableSize}>
          <Thead>
            <Tr>
              <Th>Investment Name</Th>
              <Th>Type</Th>
              <Th>Investment Date</Th>
              <Th isNumeric>Investment Value</Th>
              <Th isNumeric>Fair Market Value</Th>
              <Th isNumeric>MoC</Th>
            </Tr>
          </Thead>
          <Tbody>
          {filteredInvestments.length > 0 ? (
            filteredInvestments.map((investment, index) => (
              <Tr
                key={index}
                onClick={() => handleRowClick(investment.investmentName)}
                _hover={{ cursor: "pointer", backgroundColor: "gray.100" }}
              >
                <Td fontWeight={500}>{investment.investmentName}</Td>
                <Td>
                  <Tag gap={1}>
                    <Box
                      as="span"
                      bg={fund.investmentStrategy.color}
                      h="6px"
                      w="6px"
                      borderRadius={"full"}
                    />
                    <TagLabel>{investment.type}</TagLabel>
                  </Tag>
                </Td>
                <Td>
                  <Badge colorScheme="transparent">
                    {formatDate(investment.investmentDate)}
                  </Badge>
                </Td>
                <Td isNumeric>
                  {fund.fundCurrency.ISO} {formatMillions(investment.investmentValue)}
                </Td>
                <Td isNumeric>
                  {fund.fundCurrency.ISO} {formatMillions(investment.fairMarketValue)}
                </Td>
                <Td isNumeric>{investment.moc}</Td>
              </Tr>
            ))

          ) : (
                          <Tr>
                            <Td colSpan="6">
                              <Text textAlign="center" py={10} color="gray.500">
                              No investments match your filters
                              </Text>
                            </Td>
                          </Tr>
                        )}
          </Tbody>
        </Table>
      </TableContainer>

     
    </Flex>
  );
};

export default InvestmentsTable;

